import { Deserializable } from '../../protocols/deserializable';
import { LookAheadItem } from '../../../views/shared/components/search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';
import { BaseUser } from '../../base/base-user';
import { MfaType } from '../../types/dto/mfa-type';
import { DateUtils } from '../../../utils/date-utils';
import { Gender } from '../../types/dto/gender';
import { EmploymentStatusTypeId } from '../../employers/enum/employment-status-type-id';
import { EmploymentStatusType } from '../../employers/employer-history/types/employment-status-type';

export class EmployerUser extends BaseUser implements Deserializable, LookAheadItem {
  public birthDate!: string | null;
  public genderId!: number;
  public gender!: Gender;
  public employerId!: number;
  public employerName!: string;
  public setInactiveById: number | null = null;
  public setInactiveByName: string | null = null;
  public setInactiveDate: string | null = null;

  public mfaTypeId!: number;
  public mfaType!: MfaType;

  public employmentStatusId!: EmploymentStatusTypeId;
  public employmentStatus!: EmploymentStatusType;

  // Not From API
  public mfaActive!: boolean;
  public setToInactiveString: string = '';

  onDeserialize() {
    super.onDeserialize();
    if (!this.active && !!this.setInactiveDate) {
      this.setToInactiveString = `Set to inactive by ${this.setInactiveByName} on ${DateUtils.formatDateStringToCSTDate(
        this.setInactiveDate
      )}`;
    }
    if (!!this.gender) {
      this.gender = window.injector.Deserialize.instanceOf(Gender, this.gender);
    }
    if (!!this.employmentStatus) {
      this.employmentStatus = window.injector.Deserialize.instanceOf(EmploymentStatusType, this.employmentStatus);
    }
  }

  // Look ahead item interface

  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return 'disabled';
  }
}
